import { useCallback, useState } from 'react'

interface UseAsyncRunnerResult {
    isRunning: boolean
    run: <T>(fn: () => Promise<T>) => Promise<T>
}

/** Tracks an `isRunning` flag around an async action, regardless of whether it resolves or throws. */
export function useAsyncRunner(): UseAsyncRunnerResult {
    const [isRunning, setIsRunning] = useState(false)

    const run = useCallback(async <T>(fn: () => Promise<T>): Promise<T> => {
        setIsRunning(true)
        try {
            return await fn()
        } finally {
            setIsRunning(false)
        }
    }, [])

    return { isRunning, run }
}
